<template>

<div class="menu">

	<router-link :to="{'name': 'Listing'}" class="menu-item" v-if="!loggedin"><app-icon name="add" /><span>List your business</span></router-link>
	<router-link :to="{'name': 'Login/Customer'}" class="menu-item" v-if="!loggedin"><app-icon name="customer" /><span>Customer login</span></router-link>
	<router-link :to="{'name': 'Login/Business'}" class="menu-item" v-if="!loggedin"><app-icon name="business" /><span>Business login</span></router-link>
	<router-link :to="{'name': 'Dashboard'}" class="menu-item" v-if="loggedin"><app-icon name="dashboard" /><span>Dashboard</span></router-link>
	<router-link :to="{'name': 'Business', params: { slug: session.business.slug }}" class="menu-item" v-if="loggedin && isSessionBusiness"><app-icon name="business" /><span>Profile</span></router-link>
	<a href="logout" class="menu-item" v-if="loggedin" v-on:click="onLogoutClick"><app-icon name="logout" /><span>Logout</span></a>

</div>

</template>

<script>

export default {

	methods: {

		onLogoutClick: function(e) {

			e.preventDefault()
			e.stopPropagation()

			this.$api.request('logout').then(function() {

				this.$router.push({
					name: 'Home'
				})

			}.bind(this))

		}

	}

}

</script>

<style scoped>

.menu {
	display: flex;
	flex-direction: row;
	align-items: center;
}

.menu-item {
	padding: 6px 6px;
    max-width: 80px;
}

.is-mobile .menu-item {
    width: 54px;
    padding: 3px 0px 0px 0px;
}

.menu-item .icon {
	font-size: 24px;
	width: 100%;
	height: 24px;
	color: var(--color-blue-light);
	text-align: center;
	transition: color 100ms linear;
}

.menu-item span {
	display: block;
	text-align: center;
	color: var(--color-blue-dark);
    font-weight: 700;
    text-transform: uppercase;
    font-size: 10px;
    padding: 7px 2px 0px 2px;
}

.is-mobile .menu-item span {
    font-size: 8px;
}

.is-desktop .menu-item:hover .icon {
	color: var(--color-blue-dark);
}

</style>